module.exports = __webpack_public_path__ + "static/img/img_guide3.1d948391.png";